(function () {
  'use strict';

  function money(cents) {
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      }).format((Number(cents) || 0) / 100);
    } catch (_err) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function parseExclude(raw) {
    return String(raw || '')
      .split('|')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);
  }

  function fetchRecs(productId, intent, limit) {
    var base = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
    var url = base + '.json?product_id=' + encodeURIComponent(productId) + '&limit=' + limit + '&intent=' + intent;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }

  function productImage(product) {
    if (!product) return '';
    function asUrl(v) {
      if (!v) return '';
      if (typeof v === 'string') return v;
      return v.src || v.url || v.featured_image || '';
    }
    var img = asUrl(product.featured_image);
    if (!img && product.images && product.images.length) img = asUrl(product.images[0]);
    if (!img && product.media && product.media.length) {
      var m = product.media[0];
      img = asUrl(m) || asUrl(m && m.preview_image);
    }
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    return img;
  }

  function mergeUnique(a, b, exclude) {
    var seen = {};
    exclude.forEach(function (h) { seen[h] = true; });
    var out = [];
    a.concat(b || []).forEach(function (p) {
      if (!p || !p.handle || seen[p.handle] || p.available === false) return;
      if (!productImage(p)) return;
      seen[p.handle] = true;
      out.push(p);
    });
    return out;
  }

  function cardHtml(product) {
    var img = productImage(product);
    var title = product.title || '';
    var price = money(product.price);
    var compare = product.compare_at_price && product.compare_at_price > product.price
      ? '<s class="wped-card__compare">' + esc(money(product.compare_at_price)) + '</s>'
      : '';
    var media = '<div class="wped-card__media"><img class="wped-card__img" loading="lazy" alt="' + esc(title) + '" src="' + esc(img) + '"></div>';
    return (
      '<article class="wped-card wped-card--filled" data-wped-pairs-filled="' + esc(product.handle) + '">' +
        '<a class="wped-card__link" href="' + esc(product.url) + '">' +
          media +
          '<h3 class="wped-card__title">' + esc(title) + '</h3>' +
          '<p class="wped-card__price">' + esc(price) + compare + '</p>' +
        '</a>' +
        '<a class="wped-card__view-btn" href="' + esc(product.url) + '">View product</a>' +
      '</article>'
    );
  }

  function ensurePairsSection(root, title, sub) {
    var existing = document.getElementById('wped-pairs-' + root.dataset.sectionId);
    if (existing) return existing;
    var section = document.createElement('section');
    section.className = 'wped wped-section wped-rail wped-isolate wped-rail--pairs';
    section.id = 'wped-pairs-' + root.dataset.sectionId;
    section.innerHTML =
      '<div class="wped-container">' +
        '<div class="wped-rail__head">' +
          '<div class="wped-rail__copy">' +
            '<h2 class="wped-rail__title">' + esc(title) + '</h2>' +
            (sub ? '<p class="wped-rail__sub">' + esc(sub) + '</p>' : '') +
          '</div>' +
        '</div>' +
        '<div class="wped-rail__grid" data-count="0"></div>' +
        '<div class="wped-rail__scroll" data-count="0"></div>' +
      '</div>';
    root.insertAdjacentElement('afterend', section);
    return section;
  }

  function syncCounts(section, root, total) {
    section.setAttribute('data-rail-count', String(total));
    var grid = section.querySelector('.wped-rail__grid');
    var scroll = section.querySelector('.wped-rail__scroll');
    if (grid) grid.setAttribute('data-count', String(total));
    if (scroll) scroll.setAttribute('data-count', String(total));
    root.setAttribute('data-pair-count', String(total));
  }

  function init(root) {
    if (!root || root.dataset.wpedPairsInit === 'true') return;
    root.dataset.wpedPairsInit = 'true';

    var productId = root.getAttribute('data-product-id');
    if (!productId) return;

    var limit = Math.max(2, parseInt(root.getAttribute('data-limit') || '8', 10) || 8);
    // Prefer complete 4-column rows on desktop
    limit = Math.min(limit, 8);
    var minCount = Math.max(2, parseInt(root.getAttribute('data-min') || '2', 10) || 2);
    var section = document.getElementById('wped-pairs-' + root.dataset.sectionId);
    var grid = section && section.querySelector('.wped-rail__grid');
    var current = grid ? grid.querySelectorAll(':scope > .wped-card').length : 0;
    if (current >= limit) {
      if (section) syncCounts(section, root, current);
      return;
    }

    var exclude = parseExclude(root.getAttribute('data-exclude'));
    // Also exclude handles already in the grid
    if (grid) {
      grid.querySelectorAll('[data-wped-pairs-filled], a[href*="/products/"]').forEach(function (node) {
        var h = node.getAttribute('data-wped-pairs-filled');
        if (!h) {
          var m = (node.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
          h = m && m[1];
        }
        if (h) exclude.push(h);
      });
    }
    var title = root.getAttribute('data-pairs-title') || 'Pairs well with';
    var sub = root.getAttribute('data-why') || '';

    fetchRecs(productId, 'complementary', limit * 2)
      .then(function (comp) {
        return fetchRecs(productId, 'related', limit * 2).then(function (related) {
          return mergeUnique(comp, related, exclude).slice(0, Math.max(0, limit - current));
        });
      })
      .then(function (items) {
        if (!items.length) {
          if (section && current) syncCounts(section, root, current);
          return;
        }
        if (!section && (current + items.length) < minCount) return;
        if (!section) section = ensurePairsSection(root, title, sub);
        grid = section.querySelector('.wped-rail__grid');
        var scroll = section.querySelector('.wped-rail__scroll');
        if (!grid || !scroll) return;
        items.forEach(function (product) {
          var html = cardHtml(product);
          grid.insertAdjacentHTML('beforeend', html);
          scroll.insertAdjacentHTML('beforeend', html);
        });
        var total = grid.querySelectorAll(':scope > .wped-card').length;
        syncCounts(section, root, total);
      });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-wped-pairs-fill]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
